import React from 'react';
import { useInView } from 'react-intersection-observer';

/**
 * LazyLoad component compatible with React 19
 * Drop-in replacement for react-lazyload with same API
 * 
 * Usage (same as react-lazyload):
 * <LazyLoad width={800} height={127}>
 *   <img src="..." />
 * </LazyLoad>
 */
const LazyLoad = ({ children, width, height, offset = 100, ...props }) => {
    const { ref, inView } = useInView({
        triggerOnce: true,
        rootMargin: `${offset}px`,
    });

    return (
        <div ref={ref} style={{ width, height, ...props.style }}>
            {inView ? children : <div style={{ width, height }} />}
        </div>
    );
};

export default LazyLoad;

